import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { NodeManagerComponent } from './components/node-management/node-manager/node-manager.component';
import { BackupSchedulesComponent } from './components/backups/backup-schedules/backup-schedules.component';
import { BackupDevicesComponent } from './components/backups/backup-devices/backup-devices/backup-devices.component';
import { UpdateManagerComponent } from './components/updates/update-manager/update-manager.component';
import { NodeConfigurationMainComponent } from './components/node-management/node-configuration/node-configuration-main/node-configuration-main.component';
import { NodeLifecycleComponent } from './components/node-management/node-lifecycle/node-lifecycle.component';
import { AlertsComponent } from './components/alerts/alerts/alerts.component';
import { NodeHistoryComponent } from './components/node-history/node-history.component';
import { ProtectionPoliciesComponent } from './components/protection-policies/protection-policies.component';
import { BlockIpComponentList } from './components/block-ip-list/block-ip-list.component';
import { UserManagementComponent } from './components/user-management/user-management.component';

const routes: Routes = [
    { path: "", redirectTo: 'dashboard', pathMatch: "full" },
    { path: "dashboard", component: DashboardComponent, pathMatch: "full" },
    { path: "alerts", component: AlertsComponent, pathMatch: "full" },
    { path: "user-management", component: UserManagementComponent, pathMatch: "full" },
    { path: "node-manager", component: NodeManagerComponent, pathMatch: "full" },
    { path: "node-manager/configure/:id", component: NodeConfigurationMainComponent },
    { path: "node-manager/lifecycle/:id/:guid", component: NodeLifecycleComponent },
    { path: "node-manager/history/:id", component: NodeHistoryComponent, pathMatch: "full" },
    { path: "backup-schedules", component: BackupSchedulesComponent, pathMatch: "full" },
    { path: "backup-devices", component: BackupDevicesComponent, pathMatch: "full" },
    { path: "updates", component: UpdateManagerComponent, pathMatch: "full" },
    { path: "block-ip", component: BlockIpComponentList, pathMatch: "full" },
    { path: "protection-policies", component: ProtectionPoliciesComponent, pathMatch: "full" },
    { path: "login", component: LoginComponent, pathMatch: "full" },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
